import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "./i18n";

const PrefsContext = createContext(null);

const read = (k, fallback) => {
  try {
    return localStorage.getItem(k) || fallback;
  } catch {
    return fallback;
  }
};

export const PrefsProvider = ({ children }) => {
  const [lang, setLang] = useState(() => read("rt_lang", "ms"));
  const [theme, setTheme] = useState(() => read("rt_theme", "dark"));

  useEffect(() => {
    localStorage.setItem("rt_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("rt_theme", theme);
    document.documentElement.classList.toggle("light", theme === "light");
  }, [theme]);

  return (
    <PrefsContext.Provider value={{ lang, setLang, theme, setTheme, t: dict[lang] ?? dict.ms }}>
      {children}
    </PrefsContext.Provider>
  );
};

export const usePrefs = () => useContext(PrefsContext);
export const useT = () => usePrefs().t;
